import primeiconsWoff2Url from 'primeicons/fonts/primeicons.woff2?url'
import primeiconsWoffUrl from 'primeicons/fonts/primeicons.woff?url'

const addPreloadLink = (href: string, type: string) => {
  if (!href) return

  const exists = Array.from(
    document.head.querySelectorAll('link[rel="preload"]')
  ).some((link) => link.getAttribute('href') === href)

  if (exists) return

  const link = document.createElement('link')
  link.rel = 'preload'
  link.as = 'font'
  link.href = href
  link.type = type
  link.crossOrigin = 'anonymous'
  document.head.appendChild(link)
}

export const preloadPrimeIcons = () => {
  addPreloadLink(primeiconsWoff2Url, 'font/woff2')
  addPreloadLink(primeiconsWoffUrl, 'font/woff')
}
